enum ProductOrderStatus {
    PENDING="PENDING",
    PAYED="PAYED",
    COMPLETED="COMPLETED",
    CANCELED="CANCELED",
    REMOVED="REMOVED",
    ASSIGNED="ASSIGNED",
    PROCESSING="PROCESSING",
    DELIVERED="DELIVERED",
    NOT_DELIVERED="NOT_DELIVERED",
    RETRYING="RETRYING",
}

export default ProductOrderStatus;